(function () {
    // Add custom code below this line

    const handleVariantSelect = (e) => {
        setTimeout(() => {
            if (document.querySelectorAll('.product-form__submit')[0].disabled === true) {
                document.querySelectorAll('.product-form__submit')[0].disabled = false;
                e.target.click();
            }
        }, "1000");

    }

    document.addEventListener("DOMContentLoaded", function () {
        try {
            if (document.location.href.includes('/products')) {
                // document.querySelector('variant-selects').addEventListener('click', (e) => handleVariantSelect(e));
            }
        } catch (err) {
            console.error('error caught in dom ready in custom.js, err: ', err);
        }
    });
    // ^^ Keep your scripts inside this IIFE function call to
    // avoid leaking your variables into the global scope.
})();
